var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuardian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16.4434,
    width: 22.4151,
    height: 22.4151,
    rx: 8.00539,
    fill: "#BA957A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33618 33.2829L9.82086 33.6978L10.2535 33.2289L18.0081 24.8257L17.5215 24.3766L18.0082 24.8257C18.5127 24.279 18.4785 23.4267 17.9317 22.9222C17.385 22.4176 16.5327 22.4518 16.0282 22.9986L9.60106 29.9632L6.93664 27.6826C6.37143 27.1988 5.52104 27.2648 5.03725 27.83C4.55346 28.3952 4.61946 29.2456 5.18467 29.7294L9.33618 33.2829Z",
    fill: "white",
    stroke: "#7A828A",
    strokeWidth: 1.32453,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9585 16.5765V2.94342L55.4377 1.46512V17.5438L19.9585 16.5765Z",
    stroke: "#7A828A",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0189 9.82103C28.9567 9.82103 29.717 9.06076 29.717 8.12292C29.717 7.18508 28.9567 6.4248 28.0189 6.4248C27.081 6.4248 26.3207 7.18508 26.3207 8.12292C26.3207 9.06076 27.081 9.82103 28.0189 9.82103Z",
    fill: "#E0C589"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0189 10.6699C26.3173 10.6699 24.9317 11.8111 24.9317 13.2171C24.9317 13.3122 25.0064 13.3869 25.1015 13.3869H30.9362C31.0313 13.3869 31.106 13.3122 31.106 13.2171C31.106 11.8111 29.7204 10.6699 28.0189 10.6699Z",
    fill: "#E0C589"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1698 7.7832H51.4528M36.1698 11.8587H45.4488",
    stroke: "#7A828A",
    strokeWidth: 1.12075
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.283 21.0283L32.6038 19.5V36.8208L69.283 35.5V21.0283Z",
    fill: "#E0C589"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6981 26.1228H52.9811M37.6981 30.1983H46.9771",
    stroke: "#7A828A",
    strokeWidth: 1.12075
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1321 28.1606C62.0699 28.1606 62.8302 27.4004 62.8302 26.4625C62.8302 25.5247 62.0699 24.7644 61.1321 24.7644C60.1942 24.7644 59.434 25.5247 59.434 26.4625C59.434 27.4004 60.1942 28.1606 61.1321 28.1606Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1321 29.0095C59.4306 29.0095 58.0449 30.1507 58.0449 31.5567C58.0449 31.6518 58.1196 31.7265 58.2147 31.7265H64.0494C64.1445 31.7265 64.2192 31.6518 64.2192 31.5567C64.2192 30.1507 62.8336 29.0095 61.1321 29.0095Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9585 53.5765V39.9434L55.4377 38.4651V54.5438L19.9585 53.5765Z",
    stroke: "#7A828A",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5283 46.5002C29.4661 46.5002 30.2264 45.74 30.2264 44.8021C30.2264 43.8643 29.4661 43.104 28.5283 43.104C27.5905 43.104 26.8302 43.8643 26.8302 44.8021C26.8302 45.74 27.5905 46.5002 28.5283 46.5002Z",
    fill: "#E0C589"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5283 47.3491C26.8268 47.3491 25.4411 48.4903 25.4411 49.8963C25.4411 49.9914 25.5158 50.0661 25.6109 50.0661H31.4457C31.5408 50.0661 31.6155 49.9914 31.6155 49.8963C31.6155 48.4903 30.2298 47.3491 28.5283 47.3491Z",
    fill: "#E0C589"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6792 44.4624H51.9623M36.6792 48.5379H45.9582",
    stroke: "#7A828A",
    strokeWidth: 1.12075
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardian);
export default __webpack_public_path__ + "static/media/guardian.b78e3fa2afcdaeb73772788490b7c427.svg";
export { ForwardRef as ReactComponent };